module.exports = __webpack_public_path__ + "img/4520.079af5f9.jpg";